<script>

export default {
    name: 'MessageContentFile',
    props: {
        content: {
            type: Object
        },
        time: {
            type: String
        },
        isVisitor: {
            type: Boolean
        }
    },
    computed: {
        fileName () {
            if (this.content.file_provider === 'line' && !this.content.url) {
                return this.content.file_name || this.content.file_type
            } else if (this.content.url) {
                return this.content.file_name || this.content.url.split('/').pop()
            }
            return ''
        },
        isImage () {
            if (['line', 'google_biz_msg'].includes(this.content.file_provider)) {
                return this.content.file_type === 'image'
            }
            try {
                if (this.fileName) {
                    let unParams = this.fileName.split('?')[0]
                    let ext = unParams.split('.').pop().toLowerCase()
                    let imageExt = ['tif', 'png', 'gif', 'ico', 'jpg', 'jpeg', 'svg']
                    return imageExt.indexOf(ext) >= 0
                }
                return false
            } catch (e) {
                return false
            }
        }
    }
}
</script>

<template>
  <div class="d-flex flex-column">
    <img class="file-image" :src="content.url" alt="image" v-if="isImage"/>
    <div v-else class="d-flex align-center file-box">
      <svg style="width: 24px; height: 24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#7B7B7B">
        <path
            d="M14.8287 7.7574L9.1718 13.4143C8.78127 13.8048 8.78127 14.4379 9.1718 14.8285C9.56232 15.219 10.1955 15.219 10.586 14.8285L16.2429 9.17161C17.4144 8.00004 17.4144 6.10055 16.2429 4.92897C15.0713 3.7574 13.1718 3.7574 12.0002 4.92897L6.34337 10.5858C4.39075 12.5384 4.39075 15.7043 6.34337 17.6569C8.29599 19.6095 11.4618 19.6095 13.4144 17.6569L19.0713 12L20.4855 13.4143L14.8287 19.0711C12.095 21.8048 7.66283 21.8048 4.92916 19.0711C2.19549 16.3374 2.19549 11.9053 4.92916 9.17161L10.586 3.51476C12.5386 1.56214 15.7045 1.56214 17.6571 3.51476C19.6097 5.46738 19.6097 8.63321 17.6571 10.5858L12.0002 16.2427C10.8287 17.4143 8.92916 17.4143 7.75759 16.2427C6.58601 15.0711 6.58601 13.1716 7.75759 12L13.4144 6.34319L14.8287 7.7574Z"></path>
      </svg>
      {{ fileName }}
    </div>
    <span class="chat-time" :class="{'align-self-end': !isVisitor}">{{ time | formatTimeHM }}</span>
  </div>
</template>

<style scoped lang="scss">
.chat-time {
  color: #7B7B7B;
  font-size: 12px;
  float: right;
}

.file-image {
  object-fit: cover;
  width: 80%;
  border-radius: 6px;
  border: 1px solid #EDEDED;
}
.file-box {
  gap: 6px;
  color: #7B7B7B;
  border-radius: 6px;
  border: 1px solid #EDEDED;
  padding: 4px 10px;
}
</style>
